const language = [];

language["en"] = {
  close: "Close",
  name:"Name",
  last_name:"Last Name",
  user: "User",
  password: "Password",
  repeat_password: "Repeat Password",
  email:"Email",
  address:"Address",
  phone:"Phone",
  login:"Login",
  logout:"Logout",
  sign_up: "Sign up",
  the_field_is_required: "The field is required",
  the_email_must_be_valid: "The email must be valid",
  invalid_username_or_password:"Invalid username or password",
  invalid_username:"Invalid username",
  an_error_has_occurred_try_again_later:"An error has occurred, try again later",
  select_the_office:"Select the Office",
  select_the_type_of_identification:"Select the Type of Identification",
  identification_number:"Identification Number",
  select_the_province:"Select the Province",
  referred_by:"Referred by",
  read_terms_and_conditions:"Read Terms and Conditions",
  i_accept_contract:"I accept contract",
  the_key_must_be_the_same:"The key must be the same",
  the_email_or_the_id_is_already_registered:"The Email or the ID is already registered",
  terms_and_conditions:"Terms and Conditions",
  my_packages:"My Packages",
  date:"Date",
  weight:"Weight",
  pound:"pound",
  pounds:"pounds",
  ship_via:"Ship Via",
  change_shipment_type:"Change Shipment Type",
  tracking_no:"Tracking No.",
  pack_no:"Pack No.",
  upload_invoice:"Upload Invoice",
  cancel:"Cancel",
  save:"Save",
  status:"Status",
  pre_alerts:"Pre-alerts",
  supplier:"Supplier",
  cost:"Cost",
  invoice_value:"Invoice value US$",
  content:"Content",
  create:"Create",
  send_a_message:"Send a Message",
  message:"Message",
  send:"Send",
  news:"News",
  account_information:"Account Information",
  code:"Code",
  office:"Office",
  sector:"Sector",
  office_address:"Office Address",
  email_office:"Office email",
  schedule:"Schedule",
  see_on_the_map:"See on the map",
  qr_Code:"QR Code",
  full_address:"Full address",
  city:"City",
  state:"State",
  zipcode:"Zipcode",
  ask_for_information:"Ask for information",
  enter_the_tracking_number:"Enter the tracking number",
  consult:"Consult",
  query_detail:"Query detail",
  Carrier:"Carrier",
  entry_date:"Entry date",
  registration_date:"Registration date",
  pending_invoices:"Pending invoices",
  total_to_pay:"Total a pagar",
  currency:"Currency",
  credit_days:"Credit days",
  creation_date:"Creation date",
  change_language:"Change language",
  english:"English",
  espanish:"Espanish",
  forget_your_password:"Forget your password?",
  reset_my_password:"Reset my password",
  check_your_email:"Check your email, A verification email was sent.",
  validate_code:"Validate code",
  you_have_no_data_available:"YOU DON'T HAVE ANY DATA YET",
  you_have_no_packages_available:"YOU DON'T HAVE ANY PACKAGES YET",
  refresh: "Refresh",
  view_details: "View Details",
  details: "Details"
}
language["es"] = {
  close: "Cerrar",
  name:"Nombre",
  last_name:"Apellido",
  user : "Usuario",
  password: "Clave",
  repeat_password: "Repite La Contraseña",
  email:"Correo Electrónico",
  address:"Dirección",
  phone:"Teléfono",
  login: "Iniciar Sesión",
  logout:"Salir",
  sign_up:"Regístrate",
  the_field_is_required:"El campo es obligatorio",
  the_email_must_be_valid:"El email debe ser válido",
  invalid_username_or_password:"Usuario o Clave inválidos",
  invalid_username:"Usuario inválido",
  an_error_has_occurred_try_again_later:"Ha ocurrido un error, inténtalo de nuevo más tarde",
  select_the_office:"Selecciona La Oficina",
  select_the_type_of_identification:"Selecciona El Tipo De Identificación",
  identification_number:"Número De Identificación",
  select_the_province:"Seleccione la provincia",
  referred_by:"Referido por",
  read_terms_and_conditions:"Leer términos y condiciones",
  i_accept_contract:"Acepto contrato",
  the_key_must_be_the_same:"La clave debe ser la misma",
  the_email_or_the_id_is_already_registered:"El correo electrónico o la identificación ya están registrados",
  terms_and_conditions:"Términos y Condiciones",
  my_packages:"Mis Paquetes",
  date:"Fecha",
  weight:"Peso",
  pound:"Libra",
  pounds:"Libras",
  ship_via:"Tipo de Envio",
  change_shipment_type:"Cambiar tipo de envío",
  tracking_no:"Número de Seguimiento",
  pack_no:"Guia",
  upload_invoice:"Subir Factura",
  cancel:"Cancelar",
  save:"Guardar",
  status:"Estatus",
  pre_alerts:"Pre-alertas",
  supplier:"Suplidor",
  cost:"Costo",
  invoice_value:"Valor de la Factura US$",
  content:"Contenido",
  create:"Crear",
  send_a_message:"Enviar un mensaje",
  message:"Mensaje",
  send:"Enviar",
  news:"Noticias",
  account_information:"Información de la cuenta",
  code:"Codigo",
  office:"Oficina",
  sector:"Sector",
  office_address:"Dirección oficina",
  email_office:"Email oficina",
  schedule:"Horario",
  see_on_the_map:"Ver en el mapa",
  qr_Code:"Código QR",
  full_address:"Dirección completa",
  city:"Ciudad",
  state:"Estado",
  zipcode:"Código postal",
  ask_for_information:"Solicite información",
  enter_the_tracking_number:"Ingrese el número de seguimiento",
  consult:"Consultar",
  query_detail:"Detalle de la consulta",
  Carrier:"Transportista",
  entry_date:"Fecha de entrada",
  registration_date:"Fecha de Registro",
  pending_invoices:"Facturas pendientes",
  total_to_pay:"Total to pay",
  currency:"Moneda",
  credit_days:"Días de crédito",
  creation_date:"Fecha de creación",
  change_language:"Cambiar Idioma",
  english:"Inglés",
  espanish:"español",
  forget_your_password:"¿Olvidaste tu contraseña?",
  reset_my_password:"Restablecer mi contraseña",
  check_your_email:"Revise su correo electrónico, se envió un correo electrónico de verificación.",
  validate_code:"Validar código",
  you_have_no_data_available:"NO TIENES DATOS DISPONIBLES",
  you_have_no_packages_available:"NO TIENES PAQUETES DISPONIBLES",
  refresh: "Refrescar",
  view_details: "Ver Detalles",
  details: "Detalles"

}

export default language